import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

export const styBottomPanel = (props) => {
  const {
    isRightPanelVisible,
    isTradePanelVisible,
    isBottomPanelNormal,
    isBottomPanelCollapsed,
    isBottomPanelExpand,
    withBottomPanel,
  } = props;

  let topInset = 0;
  switch (true) {
    case isBottomPanelExpand:
      topInset = '0%'; // No offset
      break;
    case isBottomPanelNormal:
      topInset = 'calc(100% - 362px)'; // BottomPanel default size 362px (show 3 rows of data)
      break;
    case isBottomPanelCollapsed:
      topInset = 'calc(100% - 40px)'; // BottomPanel Toolbar size 40px
      break;
    default:
      break;
  }

  let rightInset = 0;
  switch (true) {
    case isRightPanelVisible && isTradePanelVisible:
      rightInset = '648px'; // RightPanel size 320px + TradePanel size 320px, margin 8px
      break;
    case isRightPanelVisible && !isTradePanelVisible:
      rightInset = '324px'; // RightPanel size 320px, margin 4px
      break;
    case !isRightPanelVisible && isTradePanelVisible:
      rightInset = '324px'; // TradePanel size 320px, margin 4px
      break;
    case !isRightPanelVisible && !isTradePanelVisible:
    default:
      break;
  }

  const totalInset = `${topInset} ${rightInset} 0 0`;

  return css`
    position: absolute;
    inset: ${totalInset};
    background: ${colors.NEUTRAL_0};
    border-radius: 4px 4px 0 0;
    margin: 0 2px 0 0;
    ${isBottomPanelExpand && 'opacity: 1'};
    ${!withBottomPanel && 'visibility: hidden'};
  `;
};

export const styBottomPanelWrapper = css`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const styBottomPanelToolBar = css`
  display: flex;
  justify-content: space-between;
  height: 40px;
  background: ${colors.NEUTRAL_1};

  > div:last-child {
    display: flex;
    cursor: pointer;
  }
`;
